import { useIsElementVisible } from '#app/hooks/useIsElementVisible.js';
import { useHasMounted } from '@contra/react-hooks/useHasMounted';
import { type Ref, useEffect } from 'react';

export const usePaginatedInfiniteLoad = <T extends HTMLElement = HTMLElement>(
  loadMore: () => void,
  hasMore: boolean,
  isLoadingMore: boolean,
  observerOptions?: IntersectionObserverInit,
): Ref<T> => {
  const [observableRef, isVisible] = useIsElementVisible<T>(observerOptions);
  const { hasMounted } = useHasMounted();

  useEffect(() => {
    if (hasMounted) {
      const shouldRequestMore = hasMore && !isLoadingMore && isVisible;

      if (shouldRequestMore) {
        loadMore();
      }
    }
  }, [hasMore, hasMounted, isLoadingMore, isVisible, loadMore]);

  return observableRef;
};
